module.exports = __webpack_public_path__ + "asset/logo_19xIFiUV.png";